export const CANNED_REASON_AI_ERROR = "AI Error";
export const CANNED_REASON_WRONG_IMAGE = "Wrong Image";
export const CANNED_REASONS = [CANNED_REASON_AI_ERROR, CANNED_REASON_WRONG_IMAGE];

/** Case-insensitive match against the canned reasons. */
export const isCannedReason = (text: string): boolean =>
    CANNED_REASONS.some((c) => c.toLowerCase() === text.trim().toLowerCase());

/** Remembered reason to offer for reuse, or null when there is none or it is canned. */
export const pickReuseReason = (lastReason: string | null): string | null => {
    if (!lastReason || isCannedReason(lastReason)) return null;
    return lastReason;
};
